module.exports = __webpack_public_path__ + "static/img/Liucheng.bc28419c.png";